import styled from 'styled-components';

export const StyledCategoriesContainer = styled.div`
  margin: 1.5rem;
  max-width: 60%;
`;
